import { LOCAL_STORAGE_PREFIX, LOCAL_STORAGE_KEYS } from '../config/appConfig';

let localStorageHelper;

function LocalStorageAPI() {
  if (
    !(
      typeof localStorage === 'object' &&
      localStorage.setItem &&
      localStorage.getItem
    )
  ) {
    return {
      get: () => null,
      set: () => null,
    };
  }
  this.get = function(key) {
    let item = localStorage.getItem(key);
    if (typeof item === 'string') {
      if (item[0] === '{' && item[item.length - 1] === '}') {
        try {
          item = JSON.parse(item);
        } catch (err) {
          // do nothing - we tried to parse it but couldn't
          // so the invoking code is now responsible
        }
      }
    }
    return item;
  };
  this.set = function(key, value) {
    let valueToStore =
      typeof value === 'string' ? value : JSON.stringify(value);
    localStorage.setItem(key, valueToStore);
  };
}

function initialiseLocalStorageIfNotExists() {
  if (!localStorageHelper) {
    localStorageHelper = new LocalStorageAPI();
  }
}

export const getSessionId = () => {
  initialiseLocalStorageIfNotExists();
  return localStorageHelper.get(
    LOCAL_STORAGE_PREFIX + LOCAL_STORAGE_KEYS['session_id']
  );
};

export const storeSessionId = session_id => {
  initialiseLocalStorageIfNotExists();
  localStorageHelper.set(
    LOCAL_STORAGE_PREFIX + LOCAL_STORAGE_KEYS['session_id'],
    session_id
  );
};

export const getSessionData = defaultValue => {
  initialiseLocalStorageIfNotExists();
  return (
    localStorageHelper.get(
      LOCAL_STORAGE_PREFIX + LOCAL_STORAGE_KEYS['session_data']
    ) || defaultValue
  );
};

export const storeSessionData = sessionData => {
  initialiseLocalStorageIfNotExists();
  localStorageHelper.set(
    LOCAL_STORAGE_PREFIX + LOCAL_STORAGE_KEYS['session_data'],
    sessionData
  );
};
